import React from "react"
import Layout from "../components/Layout"
import { GatsbyImage } from "@wp/ui"
import { Link } from "gatsby"
import { graphql, PageProps } from "gatsby"
import "../styles/pages/notfound.scss"
import Img from "gatsby-image"
import ReactWOW from "react-wow"
import "animate.css"
import "../styles/app.scss"

const NotFoundPage: React.FC<PageProps<{
  image: GatsbyImage
}>> = ({ data }) => {
  const {
    image: {
      childImageSharp: { fluid: aboutPageBanner },
    },
  } = data

  return (
    <Layout
      id="notfound-page"
      title="404 Not Found"
      withFooter={false}
      leftSide={
        <ReactWOW animation="fadeIn" className="banner-image">
          <div className="banner-image animate__animated">
            <Img fluid={aboutPageBanner} alt="about page banner" />
          </div>
        </ReactWOW>
      }
      rightSide={
        <div id="notfound-container">
          <div className="info">
            <h1 className="font-head font-xl">Page was lost</h1>
            <p className="font-body font-md">
              This page isn&apos;t available
              <Link to="/" className="font-body font-md">
                go back Home
              </Link>
            </p>
          </div>
        </div>
      }
    />
  )
}

export default NotFoundPage

export const pageQuery = graphql`
  query {
    image: file(relativePath: { eq: "products-grid2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1200, quality: 65) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
